<template>
  <v-dialog v-model="value" persistent width="500">
    <v-card color="primary" dark>
      <v-img :src="image">
        <v-container fill-height fluid pa-2>
          <v-layout fill-height>
            <v-flex xs12 align-end flexbox>
              <v-btn @click="close" color="primary" icon>
                <v-icon>clear</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-img>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["value", "image"],
  data: () => ({}),
  methods: {
    close() {
      this.$emit("input", false);
    }
  }
};
</script>

<style>
</style>